<web-settings-body>
    <web-settings-breadcrumbs>
        <div class="breadcrumb-icon" (click)="setSelectedTheme()">
            <a [tooltip]="'site_styles' | translate" placement="bottom">
                <img
                    class="first-breadcrumb-icon"
                    src="./assets/img/websites/lpc-theme-settings-icon.svg"
                    alt="lpc-theme-settings-icon"
                />
            </a>
            <img
                src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                class="breadcrumb-arrow-icon"
                alt="lpc-breadcrumb-arrow-icon"
            />
        </div>
        <div class="breadcrumb-icon" (click)="setSelectedSpecificBlock(entity().parentId)">
            <a [tooltip]="'control_block' | translate" placement="bottom">
                <img
                    class="first-breadcrumb-icon"
                    src="./assets/img/websites/lpc-icon-header.svg"
                    alt="lpc-block-icon"
                />
            </a>
            <img
                src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                class="breadcrumb-arrow-icon"
                alt="lpc-breadcrumb-arrow-icon"
            />
        </div>
        <div class="breadcrumb-icon">
            <img src="./assets/img/websites/lpc-icon-row.svg" class="first-breadcrumb-icon" alt="lpc-column-icon" />
        </div>
        <div class="breadcrumb-text">
            {{ "row" | translate }}
        </div>
    </web-settings-breadcrumbs>
    <a [href]="'knowledge_base_row_link' | translate" class="kb-link" target="_blank">
        <span class="small sp-icon icon-info"> </span> {{ "knowledge_base_row_tooltip" | translate }}
        <span class="color-light small sp-icon icon-outgoing"> </span>
    </a>

    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div class="form-row">
                <div class="form-group mb-15">
                    <label class="col-xs-9 control-label">
                        {{ "control_background_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <web-color-picker [color]="backgroundColor()" (colorChangeEvent)="setBackgroundColor($event)" />
                    </div>
                </div>

                <div class="mb-20">
                    <web-background-image-settings
                        [allowImageEffects]="false"
                        [background]="background()"
                        (backgroundChange)="setBackground($event)"
                    />
                </div>

                <div class="form-group mb-10">
                    <label class="col-xs-6">
                        {{ "control_padding" | translate }}
                    </label>
                    <div class="col-xs-6 text-right">
                        <div class="preset-padding-buttons">
                            <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(0)">0</button>
                            <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(15)">15</button>
                            <button class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(30)">30</button>
                        </div>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <div class="col-xs-12 d-flex">
                        <div class="d-flex align-items-center mr-5" style="flex-grow: 1">
                            <sp-input-num
                                suffixText="px"
                                [min]="PADDING_MIN"
                                [max]="PADDING_MAX"
                                [value]="padding()?.left"
                                (valueChange)="setPadding('left', $event)"
                            />
                        </div>
                        <div style="flex-grow: 1">
                            <div class="mb-10">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="PADDING_MIN"
                                    [max]="PADDING_MAX"
                                    [value]="padding()?.top"
                                    (valueChange)="setPadding('top', $event)"
                                />
                            </div>
                            <sp-input-num
                                suffixText="px"
                                [min]="PADDING_MIN"
                                [max]="PADDING_MAX"
                                [value]="padding()?.bottom"
                                (valueChange)="setPadding('bottom', $event)"
                            />
                        </div>
                        <div class="d-flex align-items-center ml-5" style="flex-grow: 1">
                            <sp-input-num
                                suffixText="px"
                                [min]="PADDING_MIN"
                                [max]="PADDING_MAX"
                                [value]="padding()?.right"
                                (valueChange)="setPadding('right', $event)"
                            />
                        </div>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-8 control-label">
                        {{ "control_spacing_between_columns" | translate }}
                    </label>
                    <div class="col-xs-4">
                        <sp-input-num
                            suffixText="px"
                            [min]="PADDING_MIN"
                            [max]="PADDING_MAX"
                            [value]="columnGap()"
                            (valueChange)="setColumnGap($event)"
                        />
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-xs-6 control-label">
                        {{ "control_content_alignment" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="verticalPosition()"
                            [type]="radioGroupType.verticalPosition"
                            (changeSelectedEvent)="setVerticalPosition($event)"
                        />
                    </div>
                </div>
            </div>
        </div>

        <hr class="panel-options-divider" />

        <div class="form form-horizontal">
            <div class="form-group">
                <label class="col-xs-12 control-label">
                    {{ "control_columns_in_row" | translate }}
                </label>

                @for (toggle of slotToggles(); track toggle.slot) {
                    <div class="col-xs-12">
                        <label class="checkbox-inline" [tooltip]="toggle.hint | translate" placement="right">
                            <span [class.disabled]="toggle.isDisabled">
                                <input
                                    type="checkbox"
                                    [checked]="toggle.isVisible"
                                    (change)="toggleSlot(toggle.slot, !toggle.isVisible)"
                                />
                                {{ toggle.label | translate }}
                            </span>
                        </label>
                    </div>
                }
            </div>
        </div>
    </div>
</web-settings-body>
